module.exports = __webpack_public_path__ + "static/Truck4-2ae232c5e85f6a04eecf0b0f67323f3b.png";